// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1Im3I","header":"PatientQuestionnaire_header__1oK5j","info":"PatientQuestionnaire_info__1sSJT"};